import aiApiClient from '../../../../cms/src/apiClient/ai-api-client';
import { useApplyTransactionInRange } from '../../hooks';
import { useEditorState } from '@remirror/react';
import CommandButton from '../CommandButton';
import React, { useState } from 'react';
import { message } from 'antd';

export const ImproveWritingIcon = React.memo(() => (
  <svg
    role="graphics-symbol"
    viewBox="0 0 16 16"
    className="aiImproveWriting"
    style={{
      width: '16px',
      height: '16px',
    }}
  >
    <path
      d="M8.68359 1.22168V3.32031C8.68359 3.68945 8.36914 4.00391 7.99316 4.00391C7.62402 4.00391 7.30957 3.68945 7.30957 
    3.32031V1.22168C7.30957 0.845703 7.62402 0.53125 7.99316 0.53125C8.36914 0.53125 8.68359 0.845703 8.68359 1.22168ZM10.8506 4.22266L12.3203 
    2.75293C12.5801 2.48633 13.0244 2.48633 13.2842 2.74609C13.5508 3.0127 13.5508 3.45703 13.291 3.7168L11.8213 5.18652C11.5615 5.45312 11.1104 
    5.45312 10.8506 5.19336C10.5908 4.92676 10.584 4.48242 10.8506 4.22266ZM4.16504 5.18652L2.70898 3.70996C2.44922 3.4502 2.44922 3.00586 2.70898 
    2.74609C2.96875 2.48633 3.41309 2.49316 3.67969 2.75293L5.13574 4.22266C5.39551 4.48242 5.39551 4.92676 5.12891 5.19336C4.86914 5.45312 4.4248 
    5.44629 4.16504 5.18652ZM13.4414 14.7705L6.94727 8.24219C6.62598 7.91406 6.61914 7.37402 6.94727 7.02539C7.26855 6.69043 7.83594 6.69043 8.16406 
    7.02539L14.6582 13.5537C14.9863 13.8887 14.9863 14.4287 14.6582 14.7705C14.3438 15.1055 13.7764 15.1055 13.4414 14.7705ZM1.1709 7.35352H3.27637C3.65234 
    7.35352 3.9668 7.66797 3.9668 8.03711C3.9668 8.40625 3.65234 8.7207 3.27637 8.7207H1.1709C0.801758 8.7207 0.487305 8.40625 0.487305 8.03711C0.487305 
    7.66797 0.801758 7.35352 1.1709 7.35352ZM14.8154 8.7207H12.7168C12.3477 8.7207 12.0332 8.40625 12.0332 8.03711C12.0332 7.66797 12.3477 7.35352 12.7168 
    7.35352H14.8154C15.1914 7.35352 15.5059 7.66797 15.5059 8.03711C15.5059 8.40625 15.1914 8.7207 14.8154 8.7207ZM9.5791 10.04L9.96191 9.65723L7.91113 
    7.60645C7.76758 7.46289 7.59668 7.42871 7.47363 7.54492C7.33691 7.68164 7.38477 7.8457 7.52148 7.98242L9.5791 10.04ZM2.70215 12.3506L4.17188 
    10.8945C4.43164 10.6348 4.87598 10.6348 5.13574 10.8945C5.39551 11.1611 5.39551 11.5986 5.12891 11.8652L3.66602 13.3281C3.39941 13.5879 2.95508 13.5811 
    2.68848 13.3145C2.43555 13.0547 2.43555 12.6104 2.70215 12.3506ZM8.68359 12.7607V14.8594C8.68359 15.2354 8.36914 15.5498 7.99316 15.5498C7.62402 15.5498 
    7.30957 15.2354 7.30957 14.8594V12.7607C7.30957 12.3916 7.62402 12.0771 7.99316 12.0771C8.36914 12.0771 8.68359 12.3916 8.68359 12.7607Z"
    ></path>
  </svg>
));

const prepareImproveWritingPayload = ({ selectedText, sourceId }) => ({
  action: { type: 'improve_writing' },
  source_id: sourceId,
  source: { value: selectedText },
  target: { tone: 'formal' },
});

export const ImproveWritingButton = React.memo(({ fileId }) => {
  const { updateContentInRange, deleteSelection } = useApplyTransactionInRange();
  const [loading, setLoading] = useState(false);
  const editorState = useEditorState();

  const handleOnClick = React.useCallback(() => {
    setLoading(true);
    const { from, to } = editorState.selection;
    if (from && to) {
      const selectedText = editorState.doc.slice(from, to).toString();
      aiApiClient
        .post('/ai/documents/actions', prepareImproveWritingPayload({ selectedText, sourceId: fileId }))
        .then((response) => {
          const { chat_response } = response || {};
          if (chat_response?.content) {
            deleteSelection();
            updateContentInRange({ from, content: chat_response?.content });
          }
        })
        .catch((error) => {
          console.log(error);
          message.error('Unable to improve writing due to server error.');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [editorState, prepareImproveWritingPayload, fileId]);

  return (
    <CommandButton
      label={'Improve Writing'}
      labelOptions={{ className: 'command__button-text weight-normal' }}
      loading={loading}
      icon={<ImproveWritingIcon />}
      onClick={handleOnClick}
    />
  );
});

export default ImproveWritingButton;
